import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { libraryShape, cardShape, promoShape } from '@bibliocommons/bc-prop-types';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import { selectPromoEntities } from 'app/selectors/EntitiesSelector';
import { selectCardSearchParameters } from 'app/selectors/CardsSelector';
import ModalActions from 'app/actions/ModalActions';
import PersonalizedPromotions from './PersonalizedPromotions';

export class PersonalizedPromotionsContainer extends React.PureComponent {
  render() {
    return <PersonalizedPromotions {...this.props} />;
  }
}

PersonalizedPromotionsContainer.propTypes = {
  // ownProps
  position: PropTypes.number.isRequired,
  cards: ImmutablePropTypes.listOf(cardShape),
  debugEnabled: PropTypes.bool,

  // Redux props
  currentLibrary: libraryShape.isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  promoSearchRequestId: PropTypes.string.isRequired,
  promos: ImmutablePropTypes.mapOf(promoShape).isRequired
};

const mapStateToProps = state => ({
  currentLibrary: selectCurrentLibrary(state),
  promoSearchRequestId: selectCardSearchParameters(state).get('requestId'),
  promos: selectPromoEntities(state)
});

const mapDispatchToProps = dispatch => ({
  modalActions: bindActionCreators(ModalActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(PersonalizedPromotionsContainer);
